// Static copy for the "Tumbulgum's Groper" CLUB HISTORY pinned post on the
// landing page and its newspaper-style article page. Single source of truth
// for both components.
//
// The article paragraphs are verbatim from the clubhouse sign (per
// working/KIRO_GUIDANCE.md). Keep the period spellings exactly as written:
// "17st", "44gal", "3 bushell", lowercase "tweed butter factory". Do not
// "correct" them. No em dashes anywhere in this copy (house style).

// Full-size master (2600x1538, about 1.4 MB). Only offered to wide/high-DPI
// screens on the article page via srcset; never the default download.
export const GROPER_IMAGE_SRC = '/club-history/groper-panel-web.jpg';

// Resized web copies (same image, same 2600:1538 aspect, made with sips).
export const GROPER_IMAGE_960 = '/club-history/groper-panel-960.jpg';
export const GROPER_IMAGE_1600 = '/club-history/groper-panel-1600.jpg';
export const GROPER_IMAGE_WIDTH = 2600;
export const GROPER_IMAGE_HEIGHT = 1538;

export const GROPER_ARTICLE_PATH = '/club-history/tumbulgums-groper';

export const GROPER_CARD = {
  pill: 'PINNED',
  tag: 'CLUB HISTORY',
  headline: "Tumbulgum's Groper | The 800lb Monster of 1928",
  teaser:
    "Joe Ostram spotted a dark shape in the river beside the ferry, where children were swimming. What he did next, with a blacksmith's hook, a calf for bait and a 44-gallon drum, became Tumbulgum legend.",
  dateLabel: 'A Tweed River story, 1928',
  imageAlt:
    'Painting of the 800lb groper caught at Tumbulgum in 1928, with the story from the clubhouse sign',
} as const;

export const GROPER_ARTICLE = {
  masthead: 'Tumbulgum Fishing Club',
  mastheadPlace: 'Tumbulgum, N.S.W.',
  dateline: 'A Tweed River story | 1928',
  headline: "Tumbulgum's Groper",
  subhead: 'The 800-Pound Monster of the Tweed | A Feat of Nerve and Bush Ingenuity',
  figureAlt: "The Tumbulgum's Groper painting",
  figcaption:
    'The commemorative painting of the Groper, depicted at half its true size, on display at the Club.',
  paragraphs: [
    'This painting depicts the groper (at 1/2 size) caught at Tumbulgum in 1928 by Joe Ostram. It weighed in at 800lb (364kg) and was shown at the Tweed Show. A 17st man could sit in its mouth with head room. A full mould of ice in its mouth looked like a loaf of sugar.',
    'Joe was working on the mountainside when he noticed a dark shape moving in the river while children were bathing nearby. He downed tools, raced down, crossed the river on the ferry and got the kids out; had a blacksmith make a hook, baited it with the hind of a calf and used a 44gal drum for a float with a 3 bushell bag of rocks for an anchor. The lure was set, the first bite nearly sunk the drum but it soon tired and drowned. It was rushed to the freezer of the tweed butter factory until the show!',
  ],
  footer:
    'Reproduced by the Tumbulgum Fishing Club from the commemorative sign on the clubhouse verandah.',
} as const;
